export default __webpack_public_path__ + "static/media/buildingWeb.e83ee452.jpg";